/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_ForbiddenInputs */

const cs_integrations_section_forbidden = /** @type {(inputs: Integrations_Section_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato sekce je dostupná jen správcům.`)
};

const en_integrations_section_forbidden = /** @type {(inputs: Integrations_Section_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This section is available to admins only.`)
};

/**
* | output |
* | --- |
* | "This section is available to admins only." |
*
* @param {Integrations_Section_ForbiddenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_forbidden = /** @type {((inputs?: Integrations_Section_ForbiddenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_ForbiddenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_forbidden(inputs)
	return cs_integrations_section_forbidden(inputs)
});